import {getAPIGatewayDataFromParent} from "../../handler/ParentDataHandler";
import {logOperationalMetric} from "../../util/CommonUtils";

const metricProcessName = "SCC_PACKAGE_SEARCH";
export async function getContainerHistoryData(containerLabel,
     nodeId, pageSize, pageToken = null, fromEpochMilli = null, toEpochMilli = null) {
    const requestBody = {
        "containerLabel": containerLabel,
        "nodeId": nodeId,
        "pageSize": pageSize,
        "pageToken": pageToken,
        "startTime": fromEpochMilli,
        "endTime": toEpochMilli
    }
    const startTime = Date.now();
    
    const request = {
        resourcePath: "/os/getContainerHistoryData",
        httpMethod: "post",
        processName: "oculus",
        requestBody: requestBody
    }

    try {
        const response = await getAPIGatewayDataFromParent(request);
        if (response.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getContainerHistoryData", true);
            return response.data;
        } else {
            logOperationalMetric(startTime, metricProcessName, "getContainerHistoryData", false);
            return {
                containerHistory: [],
                nextPageToken: null
            }
        }
    } catch (error) {
        return {
            containerHistory: [],
            nextPageToken: null
        }
    }

}


// WEBPACK FOOTER //
// ./src/commons/api/GetContainerHistoryResults.js